import {kSystemIcons} from "../../../constants/icons";

export default function BrevetLevelASeeDetailButton({onButtonClick}) {
    // Used in BrevetLevelAsItem to display one single button
    // for

    // BUILD
    return (
        <div className={"relative group flex justify-end"}
             onClick={onButtonClick}>
            <div className={"cursor-pointer text-backgroundLight5 flex space-x-[6px] justify-center items-center rounded-[8px] bg-greenStar hover:bg-greenStar/90 h-[32px] min-h-[32px] pl-[8px] pr-[10px]"}>
                <i className="material-icons text-[16px] mt-[1px]">
                    {kSystemIcons.eye}
                </i>
                <span className={"text-[14px] font-medium whitespace-nowrap"}>
                    {"Voir détail"}
                </span>
            </div>
        </div>
    );
}